<template>
  <div>
    <div class="modal-header">
      <button :disabled="isLoading" type="button" class="close" @click="hide()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title">Zamień produkt: {{ productToReplace.name }}</h4>
    </div>
    <div class="modal-body">
      <replace-product ref="replaceProduct"
                       :plan="plan"
                       :food="food"
                       :product-to-replace="productToReplace"
                       :product-replacement="productReplacement"
      ></replace-product>
    </div>
    <div class="modal-footer">
      <slot name="prevModal"></slot>
      <loading-button :loading="isLoading" @click="replace()">Zamień</loading-button>
      <button :disabled="isLoading" class="btn btn-success pull-right" @click="hide()">Zamknij</button>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState,} from 'vuex';

export default {
  data() {
    return {
      productToReplace: null,
      food: null,
      plan: null,
      day: null,
      productReplacement: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      modalData: state => state.modal.data,
    }),

  },
  created() {
    this.handleProductsReplacedEvent = ((replacedIn) => {
      this.isLoading = false;
      this.hideModal();
      if (replacedIn === 'food') {
        this.showModal({
          component: 'edit-food-modal',
          data: {
            dayId: this.day.id,
            planId: this.plan.id,
            foodId: this.food.id,
            productReplaced: true
          },
          options: {large: true},
        });
      }
      if (replacedIn === 'plan') {
        this.showModal({
          component: 'search',
          data: {
            dayId:this.day.id,
            planId: this.plan.id,
            productReplaced: true,
          },
          options: {large: true},
        });
      }
    });
    this.$root.$on('products-replaced', this.handleProductsReplacedEvent);
  },
  beforeDestroy() {
    this.$root.$off('products-replaced', this.handleProductsReplacedEvent);
  },
  methods: {
    ...mapMutations([
      'hideModal',
      'showModal'
    ]),
    hide() {
      this.hideModal();
    },

    replace() {
      this.isLoading = true;
      this.$refs.replaceProduct.replaceProduct();
    }
  },
  watch: {
    modalData: {
      immediate: true,
      handler: function (data) {
        this.productToReplace = data.productToReplace;
        this.food = data.food;
        this.plan = data.plan;
        this.day = data.day;
        this.productReplacement = data.productReplacement;
      },
    },
  },
};
</script>
